"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.regexp.replace");
var _member = require("@/api/member/member");
var _dataAdmin = require("@/api/dataAdmin");
var _AcquisitionTime = require("@/utils/AcquisitionTime");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      value1: [],
      minNum: '',
      maxNum: '',
      grade: '',
      options: [],
      statusTypeDataIndex: 1,
      sort: {
        orderBy: '',
        sortType: ''
      },
      statusTypeData: [{
        name: '今日',
        id: 1
      }, {
        name: '昨日',
        id: 2
      }, {
        name: '前天',
        id: 8
      }, {
        name: '近7天',
        id: 3
      }, {
        name: '近30天',
        id: 4
      }, {
        name: '近60天',
        id: 5
      }, {
        name: '近90天',
        id: 7
      }, {
        name: '自定义',
        id: 6
      }]
    };
  },
  mounted: function mounted() {
    if (localStorage.getItem('dataAdmin_query')) {
      console.log(localStorage.getItem('dataAdmin_query'));
      var data = JSON.parse(localStorage.getItem('dataAdmin_query'));
      this.value1 = [data.startTime, data.endTime];
      this.minNum = data.gtFansCount;
      this.maxNum = data.ltFansCount;
      this.grade = data.grade;
      this.page = data.page;
      this.size = data.size;
    } else {
      this.value1 = [(0, _AcquisitionTime.weekDay)(0)[0], (0, _AcquisitionTime.weekDay)(0)[0].replace('00:00:00', '23:59:59')];
    }
    this.memberQueryMemberGradeApi();
    this.onStatusList({
      id: 1
    });
  },
  methods: {
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.listBalance();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.listBalance();
    },
    listBalance: function listBalance() {
      var _this = this;
      var obj = {
        startTime: this.value1.length > 0 ? this.value1[0] : null,
        endTime: this.value1.length > 0 ? this.value1[1] : null,
        grade: this.grade,
        sort: this.sort,
        gtFansCount: this.minNum,
        ltFansCount: this.maxNum,
        page: this.page,
        size: this.size
      };
      this.loading = true;
      (0, _dataAdmin.queryList)(obj).then(function (res) {
        _this.tableData = res.data.data;
        _this.total = res.data.total;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
      console.log(obj);
    },
    sortChange: function sortChange(a) {
      console.log(a);
      var obj = {
        fansCount: 0,
        orderCount: 1
      };
      var obj2 = {
        ascending: 1,
        descending: 0
      };
      this.sort.orderBy = obj[a.prop];
      this.sort.sortType = a.order === null ? '' : obj2[a.order];
      this.listBalance();
    },
    onStatusList: function onStatusList(data) {
      this.statusTypeDataIndex = data.id;
      if (data.id === 1) {
        this.value1 = [(0, _AcquisitionTime.weekDay)(0)[0], (0, _AcquisitionTime.weekDay)(0)[0].replace('00:00:00', '23:59:59')];
      }
      if (data.id === 2) {
        this.value1 = [(0, _AcquisitionTime.weekDay)(1)[0], (0, _AcquisitionTime.weekDay)(1)[0].replace('00:00:00', '23:59:59')];
      }
      if (data.id === 3) {
        this.value1 = (0, _AcquisitionTime.weekDay)(7);
      }
      if (data.id === 4) {
        this.value1 = (0, _AcquisitionTime.weekDay)(30);
      }
      if (data.id === 5) {
        this.value1 = (0, _AcquisitionTime.weekDay)(60);
      }
      if (data.id === 7) {
        this.value1 = (0, _AcquisitionTime.weekDay)(90);
      }
      if (data.id === 8) {
        this.value1 = [(0, _AcquisitionTime.weekDay)(2)[0], (0, _AcquisitionTime.weekDay)(2)[0].replace('00:00:00', '23:59:59')];
      }
      if (data.id === 6) {
        this.value1 = [];
        return false;
      }
      this.page = 1;
      this.listBalance();
    },
    changeDataPicker: function changeDataPicker() {
      if (this.value1 === null) {
        this.value1 = [];
      }
      this.page = 1;
      this.listBalance();
    },
    onInquire: function onInquire() {
      localStorage.setItem('dataAdmin_query', JSON.stringify({
        startTime: this.value1.length > 0 ? this.value1[0] : null,
        endTime: this.value1.length > 0 ? this.value1[1] : null,
        grade: this.grade,
        sort: this.sort,
        gtFansCount: this.minNum,
        ltFansCount: this.maxNum,
        page: this.page,
        size: this.size
      }));
      this.page = 1;
      this.listBalance();
    },
    onInitialize: function onInitialize() {
      this.statusTypeDataIndex = 1;
      this.value1 = [(0, _AcquisitionTime.weekDay)(0)[0], (0, _AcquisitionTime.weekDay)(0)[0].replace('00:00:00', '23:59:59')];
      this.minNum = '';
      this.maxNum = '';
      this.grade = '';
      this.page = 1;
      this.listBalance();
      localStorage.setItem('dataAdmin_query', JSON.stringify({
        startTime: this.value1.length > 0 ? this.value1[0] : null,
        endTime: this.value1.length > 0 ? this.value1[1] : null,
        grade: this.grade,
        sort: this.sort,
        gtFansCount: this.minNum,
        ltFansCount: this.maxNum,
        page: this.page,
        size: this.size
      }));
    },
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context.v;
              this.options = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }()
  }
};